import React, { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";

const CompareContext = createContext(null);
const KEY = "compare_ids_v1";

export function CompareProvider({ children }) {
  const [ids, setIds] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
  });

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(ids)); }, [ids]);

  const add = (id) => {
    if (ids.includes(id)) return;
    if (ids.length >= 4) {
      toast.error("You can compare up to 4 properties");
      return;
    }
    setIds([...ids, id]);
    toast.success("Added to compare");
  };
  const remove = (id) => setIds(ids.filter((x) => x !== id));
  const clear = () => setIds([]);
  const toggle = (id) => (ids.includes(id) ? remove(id) : add(id));

  return (
    <CompareContext.Provider value={{ ids, add, remove, clear, toggle }}>
      {children}
    </CompareContext.Provider>
  );
}

export const useCompare = () => useContext(CompareContext);
